import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      welcome: 'Welcome to FiluetShip console!',
      greeting: 'Hello, {{username}}👋!',
      changeLanguage: 'Change Language',
      logout: 'Log out',
      login: 'Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Login',
      signUp: 'Sign up',
      loginInProgress: 'Please wait...',
      toLigthSide: 'Switch to Ligth theme',
      toDarkSide: 'Switch to Dark theme',
      observability: 'Observability',
      demo: 'Demo',
      observabilityTabGrafana: 'Grafana',
      observabilityTabJaeger: 'Tracing',
      observabilityTabFlower: 'Background tasks',
      outgoingWebhooks: 'Outgoing webhooks',
      incomingWebhooks: 'Incoming webhooks',
      incomingWebhooksEndpoints: 'Incoming webhooks endpoints',
      refresh: 'Refresh',
      From: 'From',
      To: 'To',
      'Items per page': 'Items per page',
      Prev: 'Prev',
      Next: 'Next',
      Page: 'Page',
      of: 'of',
      Timestamp: 'Timestamp',
      Provider: 'Provider',
      country: 'Country',
      Payload: 'Payload',
      History: 'History',
      'Webhook history': 'Webhook history',
      'No data': 'No data',
      loading: 'Loading...',
      Webhook: 'Webhook',
      'No webhook subscriptions yet': 'No webhook subscriptions yet',
      EditSubscription: 'Edit subscription',
      URL: 'URL',
      Secret: 'Secret',
      Created: 'Created',
      Events: 'Events',
      retrySequence: 'Retry sequence (min)',
      retrySequenceHint: 'Cumulative minutes per attempt, e.g. 1, 5, 15',
      Status: 'Status',
      actions: 'Actions',
      yes: 'Yes',
      no: 'No',
      Subscriptions: 'Subscriptions',
      webhookDelivery: 'Webhook delivery',
      subscriptionId: 'Subscription',
      retryCount: 'Retry attempts',
      nextRetryAt: 'Next retry',
      errorMessage: 'Error',
      showMore: 'Show more',
      showLess: 'Show less',
      noOutgoingWebhooks: 'No outgoing webhook deliveries yet',
      'Add webhook': 'Add webhook',
      Active: 'Active',
      Paused: 'Paused',
      save: 'Save',
      Saving: 'Saving',
      Cancel: 'Cancel',
      Remove: 'Remove',
      Delete: 'Delete',
      confirmRemoveSubscription: 'Remove this webhook subscription? This action cannot be undone.',
      confirmRemoveIncomingWebhookSetting:
        'Delete this incoming webhook setting? This action cannot be undone.',
      confirmRemoveCompany: 'Remove this company? This action cannot be undone.',
      ShowSecret: 'Show secret',
      HideSecret: 'Hide secret',
      'One per line or comma-separated': 'One per line or comma-separated',
      clients: 'Clients',
      name: 'Name',
      status: 'Status',
      total: 'Total',
      editCompany: 'Edit company',
      company: 'Company',
      noCompany: 'No company',
      companies: 'Companies',
      users: 'Users',
      email: 'Email',
      editUser: 'Edit user',
      select: 'Select…',
      invited: 'Invited',
      disabled: 'Disabled',
      changeCompany: 'Change company',
      chooseActiveCompany: 'Choose active company',
      apply: 'Apply',
      noActiveCompany: 'No active company',
      activeCompany: 'Active company',
      menu: 'Menu',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      add: 'Add',
      addCompany: 'Add company',
      create: 'Create',
      documentation: 'Documentation',
      incomingWebhooksSettingsPanel: 'Incoming webhooks',
      incomingWebhookSettingCreateTitle: 'Create incoming webhook',
      incomingWebhookSettingEditTitle: 'Edit incoming webhook',
      tenant: 'Tenant',
      tenantSettings: 'Tenant settings',
      tenantSettingsTitle: 'Tenant settings',
      tenantSettingsCreateHint: 'No settings saved yet. Fill in the form and save to create them.',
      tenantSettingsDefaultCurrency: 'Default currency',
      tenantSettingsDefaultCountry: 'Default country',
      tenantSettingsOrigin: 'Default origin address',
      tenantSettingsOriginCountry: 'Country',
      tenantSettingsOriginCity: 'City',
      tenantSettingsOriginStreet: 'Street',
      tenantSettingsOriginHouse: 'House',
      tenantSettingsOriginPostalCode: 'Postal code',
      tenantSettingsTimezone: 'Timezone',
      tenantSettingsRegistrationUrl: 'Registration URL',
      tenantSettingsDeliveryOptions: 'Delivery options (JSON)',
      tenantSettingsLoadFailed: 'Failed to load tenant settings',
      tenantSettingsSaveFailed: 'Failed to save tenant settings',
      tenantSettingsMissingToken: 'Missing access token',
      tenantSettingsMissingTenantId: 'Could not resolve tenant id for new settings',
      tenantSettingsInvalidJson: 'Delivery options must be valid JSON',
      pricingRules: 'Pricing rules',
      pricingRulesPanel: 'Pricing rules',
      pricingRuleCreateTitle: 'Create pricing rule',
      pricingRuleEditTitle: 'Edit pricing rule',
      pricingRulesEmpty: 'No pricing rules yet',
      pricingRulesLoadFailed: 'Failed to load pricing rules',
      pricingRulesSaveFailed: 'Failed to save pricing rule',
      pricingRulesDeleteFailed: 'Failed to delete pricing rule',
      pricingRulesMissingToken: 'Missing access token',
      pricingRulesMissingCompany: 'Select an active company before creating a rule',
      pricingRulesInvalidJson: 'Conditions must be valid JSON',
      pricingRulesRequiredFields: 'Provider and Currency are required',
      confirmRemovePricingRule: 'Delete this pricing rule? This action cannot be undone.',
      apiKeys: 'API Keys',
      apiKeysPanel: 'API keys',
      apiKeyCreateTitle: 'Create API key',
      apiKeyEditTitle: 'Edit API key',
      apiKeyName: 'Name',
      apiKeyValue: 'Key',
      apiKeyValueOptional: 'Key (optional)',
      apiKeyLeaveBlank: 'Leave blank to keep current key',
      apiKeyGenerate: 'Generate API key',
      apiKeyCopyHint: 'Click to copy key',
      apiKeyCopied: 'Copied',
      apiKeyGeneratedOneTimeWarning: 'The key is shown 1 time. Save it before closing this window',
      apiKeyCompany: 'Company',
      apiKeyStatusActive: 'Active',
      apiKeyStatusRevoked: 'Revoked',
      apiKeyStatusInactive: 'Inactive',
      apiKeyStatusDisabled: 'Disabled',
      apiKeysEmpty: 'No API keys yet',
      apiKeysLoadFailed: 'Failed to load API keys',
      apiKeysSaveFailed: 'Failed to save API key',
      apiKeysDeleteFailed: 'Failed to delete API key',
      apiKeysMissingToken: 'Missing access token',
      apiKeysMissingCompany: 'Select an active company before managing API keys',
      pricingService: 'Service',
      pricingCurrency: 'Currency',
      pricingMarkup: 'Markup',
      pricingMinMargin: 'Min margin',
      pricingRounding: 'Rounding',
      pricingVatTax: 'VAT/Tax',
      pricingInactive: 'Inactive',
      pricingEnvironment: 'Environment',
      consoleEnvironmentTestingMode: 'Console is running in test mode',
      consoleEnvironmentProductionMode: 'Console is running in production mode',
      consoleEnvironmentSwitchedToTesting: 'Now console works in testing mode',
      consoleEnvironmentSwitchedToProduction: 'Now console works in production mode',
      pricingDeliveryType: 'Delivery type',
      pricingMarkupPercent: 'Markup %',
      pricingMarkupFixed: 'Markup fixed',
      pricingRoundingMode: 'Rounding mode',
      pricingRoundingPrecision: 'Rounding precision',
      pricingVatPercent: 'VAT %',
      pricingTaxPercent: 'Tax %',
      pricingPriority: 'Priority',
      pricingTaxIncluded: 'Tax included',
      pricingActive: 'Active',
      pricingConditions: 'Conditions (JSON)',
      integrations: 'Integrations',
      integrationsPanel: 'Courier services accounts',
      integrationCreateTitle: 'Create courier account',
      integrationEditTitle: 'Edit courier service account',
      integrationsEmpty: 'No courier accounts yet',
      integrationsLoadFailed: 'Failed to load courier accounts',
      integrationsSaveFailed: 'Failed to save courier account',
      integrationsDeleteFailed: 'Failed to delete courier account',
      integrationsMissingToken: 'Missing access token',
      integrationsMissingCompany: 'Select an active company before creating an account',
      integrationsInvalidJson: 'Credentials summary must be valid JSON',
      integrationsRequiredFields: 'Provider and Environment are required',
      integrationsDuplicate: 'An account for this provider and environment already exists',
      confirmRemoveIntegration: 'Delete this courier account? This action cannot be undone.',
      integrationsAuthType: 'Auth type',
      integrationsCredentialsSummary: 'Credentials summary (JSON)',
      integrationsCourierCredentials: 'Courier credentials',
      integrationsCredentialsEmpty: 'No credentials for this account',
      integrationsCredentialsLoading: 'Loading credentials…',
      integrationsCredentialsAdd: 'Add credentials',
      integrationsCredentialsEditTitle: 'Courier credentials editor',
      integrationsCredentialsCreateTitle: 'Create courier credentials',
      integrationsCredentialsFields: 'Fields (JSON)',
      integrationsCredentialsSecretsRef: 'Secrets ref',
      integrationsCredentialsTokenRef: 'Token ref',
      integrationsCredentialsUpdatedAt: 'Updated at',
      integrationsCredentialsFieldsPreview: 'Fields',
      integrationsCredentialsSaveFailed: 'Failed to save courier service credentials',
      integrationsCredentialsDeleteFailed: 'Failed to delete courier service credentials',
      confirmRemoveCourierCredentials: 'Delete these courier service credentials?',
      packaging: 'Packaging',
      packagingProductsPanel: 'Products',
      packagingBoxesPanel: 'Boxes',
      packagingSelectCountry: 'First select active country',
      boxesEmpty: 'No boxes yet',
      boxesLoadFailed: 'Failed to load boxes',
      boxName: 'Name',
      boxInnerDimensions: 'Inner (L×W×H, cm)',
      boxOuterDimensions: 'Outer (L×W×H, cm)',
      boxVolume: 'Volume',
      productCreateTitle: 'Create product',
      productEditTitle: 'Edit product',
      productsEmpty: 'No products yet',
      productsLoadFailed: 'Failed to load products',
      productsSaveFailed: 'Failed to save product',
      productsDeleteFailed: 'Failed to delete product',
      productsMissingCompany: 'Select an active company before managing products',
      productsRequiredSku: 'SKU is required',
      productsInvalidDimensions: 'Dimensions and weight must be valid numbers',
      productsDuplicateSku: 'A product with this SKU already exists',
      confirmRemoveProduct: 'Delete this product? This action cannot be undone.',
      productSku: 'SKU',
      productName: 'Name',
      productLengthCm: 'Length (cm)',
      productWidthCm: 'Width (cm)',
      productHeightCm: 'Height (cm)',
      productWeightKg: 'Weight (kg)',
      productShape: 'Shape',
      productShapeBox: 'Box',
      productShapeCylinder: 'Cylinder',
      productDimensions: 'Dimensions (L×W×H, cm)',
      calculations: 'Shipments',
      ordersSearch: 'Search',
      ordersSearchPlaceholder: 'Order number or customer…',
      ordersOrderNumber: 'Order number',
      ordersCustomerId: 'Customer',
      ordersConfirmed: 'Confirmed',
      ordersDeliveryCost: 'Delivery cost',
      ordersEnvironment: 'Environment',
      ordersItemsCount: 'Items',
      ordersUpdated: 'Updated',
      ordersCalculationsCount: 'Calculations',
      ordersEmpty: 'No calculations in the selected period',
      ordersLoadFailed: 'Failed to load calculations',
      ordersMissingToken: 'Missing access token',
      ordersMissingDateRange: 'Select a date range',
      calculationDetailsTitle: 'Calculation {{calculationId}}',
      orderDetailsOpen: 'Open order details',
      orderDetailsPlaceholder: 'Order details will appear here.',
      ordersDetailsPayload: 'Calculation payload',
      ordersDetailsPayloadId: 'Payload ID',
      ordersDetailsPayloadData: 'Payload additional data',
      ordersDetailsPayloadItems: 'Order items',
      ordersDetailsPayloadSku: 'SKU',
      ordersDetailsPayloadQuantity: 'Qty',
      ordersDetailsPayloadDetails: 'Details',
      ordersDetailsPayloadDetailsOpen: 'Open payload details',
      ordersDetailsPayloadDetailsTitle: 'Payload details',
      userWidgetLanguage: 'Widget language',
      deliveryParameters: 'Delivery parameters',
      ordersDetailsNoCalculations: 'No calculations for this order',
      ordersDetailsSelectedRate: 'Selected rate',
      ordersDetailsSelectedRateCustomerAmount: 'Customer amount',
      ordersDetailsSelectedRateCarrierAmount: 'Carrier amount',
      ordersDetailsSelectedRateCarrierCurrency: 'Currency',
      ordersDetailsSelectedRateDeliveryDays: 'Delivery days',
      ordersDetailsSelectedRateNotes: 'Notes',
      ordersDetailsRates: 'Rates',
      ordersDetailsParcels: 'Parcels',
      ordersDetailsPackerBoxes: 'Boxes',
      ordersDetailsPackerResponse: 'Packer response',
      ordersDetailsShipments: 'Shipments',
      ordersDetailsNoShipments: 'No shipments for this order',
      ordersDetailsExternalOrderNumber: 'External order number',
      ordersDetailsCarrierOrderNumber: 'Carrier order number',
      ordersDetailsReference: 'Reference',
      ordersDetailsAmounts: 'Amounts',
      ordersDetailsLabelFields: 'Label fields',
      ordersDetailsPlannedBoxes: 'Planned boxes',
      ordersDetailsActualBoxes: 'Actual boxes',
      ordersDetailsCalcId: 'ID',
      ordersDetailsCalcCreated: 'Created',
      ordersDetailsCalcProvider: 'Provider',
      ordersDetailsCalcDeliveryType: 'Delivery type',
      ordersDetailsCalcPickupPoint: 'Pickup point',
      ordersDetailsCalcOrigin: 'Origin',
      ordersDetailsCalcDestination: 'Destination',
      ordersDetailsCalcParcels: 'Boxes, LxWxH, kg',
      boxesEditorTitle: 'Boxes editor',
      boxesEditorOpen: 'Edit boxes',
      boxesEditorSectionPlanned: 'PLANNED',
      boxesEditorSectionActual: 'ACTUAL',
      boxesEditorAddBox: 'Add box',
      boxesEditorAddBoxTitle: 'Add box',
      boxesEditorAddBoxConfirm: 'Add',
      boxesEditorAddBoxFailed: 'Failed to add box',
      boxesEditorRemoveBox: 'Remove box',
      boxesEditorRemoveBoxFailed: 'Failed to remove box',
      boxesEditorAddBoxInvalid: 'Selected box is invalid',
      boxesEditorAddBoxWeightRequired: 'Box weight is required',
      boxesEditorAddBoxWeightInvalid: 'Weight must be between 0.01 and 20.00 kg',
      boxesEditorAddBoxWeightHint: '0.01–20.00',
      boxesEditorActualLoadFailed: 'Failed to load actual boxes',
      boxesEditorActualLocked: 'Actual boxes cannot be changed after a shipment has been created',
      boxesEditorNone: 'No planned boxes',
      boxesEditorDimensions: 'L×W×H, cm',
      boxesEditorWeight: 'Weight, kg',
      boxesEditorVolume: 'Volume, cm³',
      ordersDetailsShipmentId: 'ID',
      ordersDetailsShipmentStatus: 'Status',
      ordersDetailsShipmentProvider: 'Provider',
      ordersDetailsShipmentTracking: 'Tracking number',
      ordersDetailsShipmentServiceCode: 'Service code',
      ordersDetailsShipmentServiceType: 'Service type',
      ordersDetailsShipmentPricingRule: 'Pricing rule',
      ordersDetailsShipmentCreated: 'Created',
      ordersDetailsShipmentUpdated: 'Updated',
      ordersPayloadsListTitle: 'Shipments/drafts',
      ordersCreateShipment: 'Create shipment',
      ordersCreateShipmentDraft: 'Create shipment draft',
      ordersCreateShipmentWarningTitle: 'Create shipment from console?',
      ordersCreateShipmentWarningMessage:
        'It is strongly not recommended to create a shipment from the FiluetShip console. Shipment registration is the warehouse\'s responsibility. If you understand the risks and consequences, you may proceed. Otherwise, cancel.',
      ordersCreateShipmentWarningProceed: 'Proceed anyway',
      ordersCreateShipmentWarningAbort: 'Cancel',
      ordersCreateMissingCompany: 'Select an active company before creating a shipment',
      ordersCreateShipmentModalTitle: 'Create shipment draft',
      ordersCreateData: 'Order data',
      ordersCreateRewardPoints: 'Reward points',
      ordersCreateDeclaredValueTotal: 'Declared value total',
      ordersCreateRecipient: 'Recipient',
      ordersCreateRecipientName: 'Name',
      ordersCreateRecipientPhone: 'Phone',
      ordersCreateRecipientEmail: 'Email',
      ordersCreateItems: 'Order items',
      ordersCreateItemSku: 'SKU',
      ordersCreateItemSkuSelect: 'Select SKU',
      ordersCreateItemQuantity: 'Quantity',
      ordersCreateItemAdd: 'Add',
      ordersCreateItemRemove: 'Remove',
      ordersCreateRequiredFields: 'Order number and customer are required',
      ordersCreateRewardPointsInvalid: 'Reward points must be a number',
      ordersCreateDeclaredValueInvalid: 'Declared value total must be a number',
      ordersCreateRecipientNameRequired: 'Recipient name is required',
      ordersCreateRecipientPhoneRequired: 'Recipient phone is required',
      ordersCreateRecipientEmailRequired: 'Recipient email is required',
      ordersCreateRecipientEmailInvalid: 'Invalid email address',
      ordersCreateItemsRequired: 'Add at least one order item',
      ordersCreateItemSkuRequired: 'Select a SKU from the list',
      ordersCreateItemQuantityInvalid: 'Quantity must be a positive number',
      ordersCreateFailed: 'Failed to create shipment',
      ordersDeleteConfirm:
        'Delete this calculation? This action cannot be undone.',
      ordersDeleteFailed: 'Failed to delete calculation',
      ordersDeleteConfirmed: 'Cannot delete a calculation confirmed by the customer',
      ordersDeleteHasShipments: 'Cannot delete a calculation that has shipments',
      ordersDeleteWarningTitle: 'Delete calculation?',
      ordersDeleteWarningMessage:
        'This will permanently remove the calculation payload and related calculation. This action cannot be undone.',
      ordersDeleteWarningProceed: 'Delete',
      ordersDeleteWarningAbort: 'Cancel',
      Deleting: 'Deleting',
      ordersCreateWidgetTitle: 'Delivery widget',
      ordersCreateWidgetMissingPayload: 'Calculation payload is missing',
      ordersCreateWidgetMissingApiKey: 'Company widget settings must include apiKey',
      ordersCreateWidgetConfigMissing:
        'Company settings are missing widgetConfig. Add it under settings.widgetConfig.',
      ordersCreateWidgetConfigLoadFailed: 'Failed to load company widget settings',
      shipmentEditorRoutingOrigin: 'Routing origin',
      shipmentEditorRoutingDestination: 'Routing destination',
      shipmentEditorRoutingReferences: 'Routing references',
      shipmentEditorLabelImages: 'Label images',
      shipmentEditorLabelImagesLoading: 'Loading label images…',
      shipmentEditorLabelImagesNone: 'No label images available',
      shipmentEditorLabelImagesError: 'Failed to load label images',
      shipmentEditorLabelPage: 'Label page {{n}}',
      shipmentEditorPrintLabel: 'Print',
      shipmentEditorZoomIn: 'Zoom in',
      shipmentEditorZoomOut: 'Zoom out',
      shipmentEditorBoxes: 'Boxes',
      shipmentEditorBoxesNone: 'No boxes',
      shipmentEditorBoxKind: 'Type',
      shipmentEditorBoxPlanned: 'Planned',
      shipmentEditorBoxActual: 'Actual',
      shipmentEditorBoxCode: 'Box code',
      shipmentEditorBoxQty: 'Qty',
      shipmentEditorTitle: 'Shipment editor — {{id}}',
      shipmentEditorOpen: 'Open shipment editor',
      shipmentEditorEdit: 'Edit',
      shipmentEditorEditTitle: 'Edit shipment {{id}}',
      shipmentEditorEditDeliveryType: 'Delivery type',
      shipmentEditorEditCourier: 'Courier',
      shipmentEditorEditPickupPoint: 'Pickup point',
      shipmentEditorEditComment: 'Comment',
      shipmentEditorEditReceiverName: 'Receiver name',
      shipmentEditorEditReceiverMobile: 'Mobile',
      shipmentEditorEditReceiverEmail: 'Email',
      shipmentEditorEditCity: 'City',
      shipmentEditorEditStreet: 'Street',
      shipmentEditorEditHouseNo: 'House no.',
      shipmentEditorEditApartmentNo: 'Apartment no.',
      shipmentEditorEditPostalCode: 'Postal code',
      shipmentEditorEditPickupPointId: 'Pickup point',
      shipmentEditorEditPickupPointSelect: 'Select a pickup point',
      shipmentEditorEditPickupPointsLoading: 'Loading pickup points…',
      shipmentEditorEditPickupPointsError: 'Failed to load pickup points',
      shipmentEditorEditCountryRequired: 'Shipment destination country is required to load pickup points',
      shipmentEditorEditSave: 'Save changes',
      shipmentEditorEditSaving: 'Saving…',
      shipmentEditorEditError: 'Failed to change shipment',
      shipmentEditorEditPickupPointRequired: 'Pickup point is required for pickup delivery',
      shipmentEditorDelete: 'Delete',
      shipmentEditorDeleteError: 'Failed to delete shipment',
      copiedToClipboard: 'Copied to clipboard',
      scrollToTop: 'Scroll to top',
      mainDashboard: 'Main dashboard',
      mainDashboardEyebrow: 'Operations / {{environment}}',
      mainDashboardSubtitle: 'A live view of your delivery operations. Welcome back, {{name}}.',
      mainDashboardShipmentRequests: 'Shipment requests',
      mainDashboardShipmentRequestsHint: 'All calculation requests',
      mainDashboardRegisteredShipments: 'Registered shipments',
      mainDashboardRegisteredShipmentsHint: 'Created with carriers',
      mainDashboardDelivered: 'Delivered',
      mainDashboardFailureRate: 'Failure rate {{value}}',
      mainDashboardServiceHealth: 'Service health',
      mainDashboardOperational: 'Operational',
      mainDashboardUnavailable: 'Unavailable',
      mainDashboardCheckingHealth: 'Checking service health...',
      mainDashboardCarrierReadiness: 'Carrier readiness',
      mainDashboardConnectedIntegrations: 'Connected carrier integrations',
      mainDashboardPickupPointsSynced: '{{count}} pickup points synced',
      mainDashboardManageIntegrations: 'Manage integrations',
      mainDashboardOpenObservability: 'Open observability',
      mainDashboardUpdatedAt: 'Updated {{time}}',
      mainDashboardLoadingLiveData: 'Loading live data...',
      mainDashboardControlPlane: 'FiluetShip control plane',
      commandPaletteOpen: 'Open command palette (Ctrl+K)',
      commandPaletteTrigger: 'Search navigation',
      commandPaletteLabel: 'Command palette',
      commandPalettePlaceholder: 'Search console...',
      commandPaletteGoTo: 'Go to',
      commandPaletteShipments: 'Shipments',
      commandPaletteNoMatches: 'No matching navigation or shipments',
      commandPaletteUnassigned: 'Unassigned',
      commandPaletteNoTracking: 'No tracking yet',
      commandPaletteDashboardHint: 'Overview and service health',
      commandPaletteShipmentsHint: 'View shipment calculations',
      commandPaletteIntegrationsHint: 'Manage carrier integrations',
      commandPaletteObservabilityHint: 'Inspect events and system activity',
      commandPalettePricingHint: 'Configure prices and markups',
      commandPaletteApiKeysHint: 'Manage API access',
      commandPaletteClientsHint: 'Manage companies and users',
      commandPalettePackagingHint: 'Manage packaging definitions',
      commandPaletteWebhooksHint: 'Review webhook deliveries',
      incidentsLabel: 'Operational incidents',
      incidentsControlPlane: 'Control plane',
      incidentsTitle: 'Operational attention',
      incidentsClose: 'Close incidents',
      incidentsRequiringAttention: 'Items requiring attention',
      incidentsChecked: 'Checked {{age}}',
      incidentsCheckingNow: 'Checking now',
      incidentsServiceHealth: 'Service health',
      incidentsServicesClear: 'All monitored services operational',
      incidentsShipmentExceptions: 'Shipment exceptions',
      incidentsNoExceptions: 'No shipment exceptions',
      incidentsUnknownOrder: 'Unknown order',
      incidentsNoTimestamp: 'No timestamp',
      providerDrawerLabel: 'Provider details',
      providerDrawerTitle: '{{provider}} operations',
      providerDrawerClose: 'Close provider details',
      providerDrawerStatus: 'Connection status',
      providerDrawerPerformance: 'Delivery performance',
      providerDrawerDelivered: 'Delivered',
      providerDrawerFailure: 'Failure',
      providerDrawerAverageCost: 'Average cost',
      providerDrawerMappings: 'Mappings',
      providerDrawerPickupPoints: 'Pickup points',
      providerDrawerLastSync: 'Last synchronized',
      providerDrawerOpenIntegration: 'Open integration settings',
      providerDrawerLatency: 'Average latency', providerDrawerCredentials: 'Credentials', providerDrawerLastErrors: 'Latest errors', providerDrawerNoErrors: 'No provider errors in this period', providerDrawerProblemShipments: 'Problem shipments', providerDrawerNoProblems: 'No problem shipments', providerDrawerLoadFailed: 'Failed to load provider details',
      operationalMap: 'Operational map',
      operationalMapLabel: 'Delivery network map',
      operationalMapLoading: 'Loading delivery network...',
      operationalMapEmpty: 'No operational locations to display',
      operationalMapUnavailable: 'The operational map is unavailable',
      operationalMapPickupPoints: 'Pickup points',
      operationalMapShipments: 'Active shipments',
      operationalMapProviders: 'Providers',
      operationalMapZoomIn: 'Zoom in',
      operationalMapZoomOut: 'Zoom out',
      operationalMapReset: 'Reset map view',
      operationalMapMissingKey: 'Google Maps API key is not configured',
      operationalMapOpen: 'Open map', operationalMapClose: 'Close map', operationalMapOnDemand: 'Load pickup-point locations only when you need to inspect the delivery network.',
      quickCreate: 'Quick create',
      quickCreateOpen: 'Open quick create',
      quickCreateClose: 'Close quick create',
      quickCreateShipment: 'Create shipment draft',
      quickCreateWebhook: 'Add webhook',
      quickCreateIntegration: 'Add integration',
      quickCreateApiKey: 'Create API key',
      quickCreatePricingRule: 'Create pricing rule',
      quickCreateTitle: 'What would you like to create?', quickCreateShipmentHint: 'Create a calculation payload and open checkout', quickCreateWebhookHint: 'Subscribe an external endpoint', quickCreateApiKeyHint: 'Issue widget or service access', quickCreateIntegrationHint: 'Connect a courier account', incidentsMarkRead: 'Mark read', incidentsWebhooks: 'Webhooks', incidentsNoWebhookFailures: 'No failed webhook deliveries', incidentsOpenFlower: 'Open retry monitor', incidentsCredentials: 'Credentials', incidentsCheckCredentials: 'Check integration credentials', incidentsCredentialsClear: 'All provider credentials configured',
      freshnessLive: 'Live',
      freshnessUpdatedMinutesAgo: 'Updated {{count}}m ago',
      freshnessUpdatedHoursAgo: '{{count}}h old',
      freshnessUpdatedDaysAgo: '{{count}}d old',
      freshnessStale: 'Stale',
      freshnessUnknown: 'Freshness unknown',
      freshnessLastUpdated: 'Last updated {{time}}',
      savedViews: 'Saved views',
      savedViewsSave: 'Save current view',
      savedViewsName: 'View name',
      savedViewsApply: 'Apply saved view',
      savedViewsDelete: 'Delete saved view',
      savedViewsEmpty: 'No saved views yet',
      savedViewsDefault: 'Default view',
      savedViewsSaveFailed: 'Failed to save view',
      savedViewsDeleteFailed: 'Failed to delete view',
      orderLifecycle: 'Order lifecycle',
      orderLifecycleCurrentStatus: 'Current status: {{status}}',
      orderLifecycleCalculation: 'Calculated',
      orderLifecycleSelected: 'Rate selected',
      orderLifecycleRegistered: 'Registered',
      orderLifecycleInTransit: 'In transit',
      orderLifecycleDelivered: 'Delivered',
      orderLifecycleException: 'Exception',
      orderLifecycleCancelled: 'Cancelled',
      orderLifecyclePending: 'Pending',
      orderLifecycleUnknown: 'Status unknown',
      asyncStateLoading: 'Loading...',
      asyncStateErrorTitle: 'Unable to load data',
      asyncStateErrorDescription: 'Something went wrong while loading this section.',
      asyncStateEmptyTitle: 'No data yet',
      asyncStateEmptyDescription: 'There is nothing to display in this section.',
      asyncStateRetry: 'Try again',
      asyncStateDiagnostics: 'View diagnostics',
    }
  },
  ru: {
    translation: {
      welcome: 'Добро пожаловать в консоль управления FiluetShip!',
      greeting: 'Привет, {{username}}👋!',
      changeLanguage: 'Сменить язык',
      logout: 'Выход',
      login: 'Вход',
      username: 'Имя пользователя',
      password: 'Пароль',
      loginButton: 'Войти',
      signUp: 'Регистрация',
      loginInProgress: 'Пожалуйста, подождите...',
      toLigthSide: 'Сменить тему на Светлую',
      toDarkSide: 'Сменить тему на Тёмную',
      observability: 'Наблюдаемость',
      demo: 'Демо',
      observabilityTabGrafana: 'Grafana',
      observabilityTabJaeger: 'Трассировка запросов',
      observabilityTabFlower: 'Фоновые задачи',
      outgoingWebhooks: 'Исходящие вебхуки',
      incomingWebhooks: 'Входящие вебхуки',
      incomingWebhooksEndpoints: 'Конечные точки входящих вебхуков',
      refresh: 'Обновить',
      From: 'С',
      To: 'По',
      'Items per page': 'На странице',
      Prev: 'Назад',
      Next: 'Вперёд',
      Page: 'Страница',
      of: 'из',
      Timestamp: 'Время',
      Provider: 'Провайдер',
      country: 'Страна',
      Payload: 'Данные',
      History: 'История',
      'Webhook history': 'История вебхука',
      'No data': 'Нет данных',
      loading: 'Загрузка...',
      Webhook: 'Вебхук',
      'No webhook subscriptions yet': 'Подписок на вебхуки пока нет',
      EditSubscription: 'Редактировать подписку',
      URL: 'URL',
      Secret: 'Секрет',
      Created: 'Создано',
      Events: 'События',
      retrySequence: 'Интервалы повтора (мин)',
      retrySequenceHint: 'Накопительные минуты для каждой попытки, напр. 1, 5, 15',
      Status: 'Статус',
      actions: 'Действия',
      yes: 'Да',
      no: 'Нет',
      Subscriptions: 'Подписки',
      webhookDelivery: 'Доставка вебхуков',
      subscriptionId: 'Подписка',
      retryCount: 'Повторные попытки',
      nextRetryAt: 'Следующая попытка',
      errorMessage: 'Ошибка',
      showMore: 'Показать ещё',
      showLess: 'Свернуть',
      noOutgoingWebhooks: 'Исходящих доставок вебхуков пока нет',
      'Add webhook': 'Добавить вебхук',
      Active: 'Активно',
      Paused: 'Приостановлена',
      save: 'Сохранить',
      Saving: 'Сохранение',
      Cancel: 'Отмена',
      Remove: 'Удалить',
      Delete: 'Удалить',
      confirmRemoveSubscription: 'Удалить эту подписку на вебхук? Это действие нельзя отменить.',
      confirmRemoveIncomingWebhookSetting:
        'Удалить эту настройку входящего вебхука? Это действие нельзя отменить.',
      confirmRemoveCompany: 'Удалить эту компанию? Это действие нельзя отменить.',
      ShowSecret: 'Показать секрет',
      HideSecret: 'Скрыть секрет',
      'One per line or comma-separated': 'По одному на строку или через запятую',
      clients: 'Клиенты',
      name: 'Название',
      status: 'Статус',
      total: 'Количество',
      editCompany: 'Редактировать компанию',
      company: 'Компания',
      noCompany: 'Без компании',
      companies: 'Компании',
      users: 'Пользователи',
      email: 'Эл. почта',
      editUser: 'Редактировать пользователя',
      select: 'Выберите…',
      invited: 'Приглашён',
      disabled: 'Отключён',
      changeCompany: 'Сменить компанию',
      chooseActiveCompany: 'Выбор активной компании',
      apply: 'Применить',
      noActiveCompany: 'Нет активной компании',
      activeCompany: 'Активная компания',
      menu: 'Меню',
      openMenu: 'Открыть меню',
      closeMenu: 'Закрыть меню',
      add: 'Добавить',
      addCompany: 'Новая компания',
      create: 'Создать',
      documentation: 'Документация',
      incomingWebhooksSettingsPanel: 'Входящие вебхуки',
      incomingWebhookSettingCreateTitle: 'Создать входящий вебхук',
      incomingWebhookSettingEditTitle: 'Изменить входящий вебхук',
      tenant: 'Тенант',
      tenantSettings: 'Настройки тенанта',
      tenantSettingsTitle: 'Настройки тенанта',
      tenantSettingsCreateHint: 'Настройки ещё не сохранены. Заполните форму и нажмите «Сохранить».',
      tenantSettingsDefaultCurrency: 'Валюта по умолчанию',
      tenantSettingsDefaultCountry: 'Страна по умолчанию',
      tenantSettingsOrigin: 'Адрес отправления по умолчанию',
      tenantSettingsOriginCountry: 'Страна',
      tenantSettingsOriginCity: 'Город',
      tenantSettingsOriginStreet: 'Улица',
      tenantSettingsOriginHouse: 'Дом',
      tenantSettingsOriginPostalCode: 'Индекс',
      tenantSettingsTimezone: 'Часовой пояс',
      tenantSettingsRegistrationUrl: 'URL регистрации',
      tenantSettingsDeliveryOptions: 'Варианты доставки (JSON)',
      tenantSettingsLoadFailed: 'Не удалось загрузить настройки тенанта',
      tenantSettingsSaveFailed: 'Не удалось сохранить настройки тенанта',
      tenantSettingsMissingToken: 'Отсутствует токен доступа',
      tenantSettingsMissingTenantId: 'Не удалось определить id тенанта для новых настроек',
      tenantSettingsInvalidJson: 'Варианты доставки должны быть в формате JSON',
      pricingRules: 'Ценообразование',
      pricingRulesPanel: 'Правила ценообразования',
      pricingRuleCreateTitle: 'Создать правило',
      pricingRuleEditTitle: 'Редактировать правило',
      pricingRulesEmpty: 'Правил ценообразования пока нет',
      pricingRulesLoadFailed: 'Не удалось загрузить правила ценообразования',
      pricingRulesSaveFailed: 'Не удалось сохранить правило',
      pricingRulesDeleteFailed: 'Не удалось удалить правило',
      pricingRulesMissingToken: 'Отсутствует токен доступа',
      pricingRulesMissingCompany: 'Выберите активную компанию перед созданием правила',
      pricingRulesInvalidJson: 'Условия должны быть в формате JSON',
      pricingRulesRequiredFields: 'Провайдер и валюта обязательны',
      confirmRemovePricingRule: 'Удалить это правило? Это действие нельзя отменить.',
      apiKeys: 'API-ключи',
      apiKeysPanel: 'API-ключи',
      apiKeyCreateTitle: 'Создать API-ключ',
      apiKeyEditTitle: 'Редактировать API-ключ',
      apiKeyName: 'Название',
      apiKeyValue: 'Ключ',
      apiKeyValueOptional: 'Ключ (необязательно)',
      apiKeyLeaveBlank: 'Оставьте пустым, чтобы не менять ключ',
      apiKeyGenerate: 'Сгенерировать API-ключ',
      apiKeyCopyHint: 'Нажмите, чтобы скопировать ключ',
      apiKeyCopied: 'Скопировано',
      apiKeyGeneratedOneTimeWarning: 'Ключ показывается 1 раз. Сохраните его перед закрытием этого окна',
      apiKeyCompany: 'Компания',
      apiKeyStatusActive: 'Активен',
      apiKeyStatusRevoked: 'Отозван',
      apiKeyStatusInactive: 'Неактивен',
      apiKeyStatusDisabled: 'Отключён',
      apiKeysEmpty: 'API-ключей пока нет',
      apiKeysLoadFailed: 'Не удалось загрузить API-ключи',
      apiKeysSaveFailed: 'Не удалось сохранить API-ключ',
      apiKeysDeleteFailed: 'Не удалось удалить API-ключ',
      apiKeysMissingToken: 'Отсутствует токен доступа',
      apiKeysMissingCompany: 'Выберите активную компанию перед управлением API-ключами',
      pricingService: 'Сервис',
      pricingCurrency: 'Валюта',
      pricingMarkup: 'Наценка',
      pricingMinMargin: 'Мин. маржа',
      pricingRounding: 'Округление',
      pricingVatTax: 'НДС/налог',
      pricingInactive: 'Неактивно',
      pricingEnvironment: 'Среда',
      consoleEnvironmentTestingMode: 'Консоль работает в режиме тестирования',
      consoleEnvironmentProductionMode: 'Консоль работает в режиме production',
      consoleEnvironmentSwitchedToTesting: 'Теперь консоль работает в режиме тестирования',
      consoleEnvironmentSwitchedToProduction: 'Теперь консоль работает в режиме production',
      pricingDeliveryType: 'Тип доставки',
      pricingMarkupPercent: 'Наценка %',
      pricingMarkupFixed: 'Фикс. наценка',
      pricingRoundingMode: 'Режим округления',
      pricingRoundingPrecision: 'Точность округления',
      pricingVatPercent: 'НДС %',
      pricingTaxPercent: 'Налог %',
      pricingPriority: 'Приоритет',
      pricingTaxIncluded: 'Налог включён',
      pricingActive: 'Активно',
      pricingConditions: 'Условия (JSON)',
      integrations: 'Интеграции',
      integrationsPanel: 'Аккаунты курьерских сервисов',
      integrationCreateTitle: 'Создать аккаунт курьера',
      integrationEditTitle: 'Редактировать аккаунт курьерской службы',
      integrationsEmpty: 'Аккаунтов курьеров пока нет',
      integrationsLoadFailed: 'Не удалось загрузить аккаунты курьеров',
      integrationsSaveFailed: 'Не удалось сохранить аккаунт курьера',
      integrationsDeleteFailed: 'Не удалось удалить аккаунт курьера',
      integrationsMissingToken: 'Отсутствует токен доступа',
      integrationsMissingCompany: 'Выберите активную компанию перед созданием аккаунта',
      integrationsInvalidJson: 'Сводка учётных данных должна быть в формате JSON',
      integrationsRequiredFields: 'Провайдер и среда обязательны',
      integrationsDuplicate: 'Аккаунт для этого провайдера и среды уже существует',
      confirmRemoveIntegration: 'Удалить этот аккаунт курьера? Действие нельзя отменить.',
      integrationsAuthType: 'Тип авторизации',
      integrationsCredentialsSummary: 'Сводка учётных данных (JSON)',
      integrationsCourierCredentials: 'Учётные данные курьерской службы',
      integrationsCredentialsEmpty: 'Нет учётных данных для этого аккаунта',
      integrationsCredentialsLoading: 'Загрузка учётных данных…',
      integrationsCredentialsAdd: 'Добавить учётные данные',
      integrationsCredentialsEditTitle: 'Редактор учётных данных курьера',
      integrationsCredentialsCreateTitle: 'Создать учётные данные курьерской службы',
      integrationsCredentialsFields: 'Поля (JSON)',
      integrationsCredentialsSecretsRef: 'Ссылка на секреты',
      integrationsCredentialsTokenRef: 'Ссылка на токен',
      integrationsCredentialsUpdatedAt: 'Обновлено',
      integrationsCredentialsFieldsPreview: 'Поля',
      integrationsCredentialsSaveFailed: 'Не удалось сохранить учётные данные курьерской службы',
      integrationsCredentialsDeleteFailed: 'Не удалось удалить учётные данные курьерской службы',
      confirmRemoveCourierCredentials: 'Удалить эти учётные данные курьерской службы?',
      packaging: 'Упаковка',
      packagingProductsPanel: 'Товары',
      packagingBoxesPanel: 'Короба',
      packagingSelectCountry: 'Сначала выберите активную страну',
      boxesEmpty: 'Коробов пока нет',
      boxesLoadFailed: 'Не удалось загрузить короба',
      boxName: 'Название',
      boxInnerDimensions: 'Внутр. (Д×Ш×В, см)',
      boxOuterDimensions: 'Внеш. (Д×Ш×В, см)',
      boxVolume: 'Объём',
      productCreateTitle: 'Создать товар',
      productEditTitle: 'Редактировать товар',
      productsEmpty: 'Товаров пока нет',
      productsLoadFailed: 'Не удалось загрузить товары',
      productsSaveFailed: 'Не удалось сохранить товар',
      productsDeleteFailed: 'Не удалось удалить товар',
      productsMissingCompany: 'Выберите активную компанию перед управлением товарами',
      productsRequiredSku: 'SKU обязателен',
      productsInvalidDimensions: 'Габариты и вес должны быть корректными числами',
      productsDuplicateSku: 'Товар с таким SKU уже существует',
      confirmRemoveProduct: 'Удалить этот товар? Это действие нельзя отменить.',
      productSku: 'SKU',
      productName: 'Название',
      productLengthCm: 'Длина (см)',
      productWidthCm: 'Ширина (см)',
      productHeightCm: 'Высота (см)',
      productWeightKg: 'Вес (кг)',
      productShape: 'Форма',
      productShapeBox: 'Короб',
      productShapeCylinder: 'Цилиндр',
      productDimensions: 'Габариты (Д×Ш×В, см)',
      calculations: 'Отправления',
      ordersSearch: 'Поиск',
      ordersSearchPlaceholder: 'Номер заказа или клиент…',
      ordersOrderNumber: 'Номер заказа',
      ordersCustomerId: 'Клиент',
      ordersConfirmed: 'Подтверждён',
      ordersDeliveryCost: 'Стоимость доставки',
      ordersEnvironment: 'Окружение',
      ordersItemsCount: 'Позиции',
      ordersUpdated: 'Обновлено',
      ordersCalculationsCount: 'Расчёты',
      ordersEmpty: 'Нет расчётов за выбранный период',
      ordersLoadFailed: 'Не удалось загрузить расчёты',
      ordersMissingToken: 'Отсутствует токен доступа',
      ordersMissingDateRange: 'Выберите период дат',
      calculationDetailsTitle: 'Расчёт {{calculationId}}',
      orderDetailsOpen: 'Открыть детали заказа',
      orderDetailsPlaceholder: 'Здесь будут отображаться детали заказа.',
      ordersDetailsPayload: 'Параметры расчёта',
      ordersDetailsPayloadId: 'ID расчёта',
      ordersDetailsPayloadData: 'Дополнительные данные расчета',
      ordersDetailsPayloadItems: 'Позиции заказа',
      ordersDetailsPayloadSku: 'Артикул',
      ordersDetailsPayloadQuantity: 'Кол-во',
      ordersDetailsPayloadDetails: 'Детали',
      ordersDetailsPayloadDetailsOpen: 'Открыть детали расчёта',
      ordersDetailsPayloadDetailsTitle: 'Детали расчёта',
      userWidgetLanguage: 'Язык виджета',
      deliveryParameters: 'Параметры доставки',
      ordersDetailsNoCalculations: 'Нет расчётов по этому заказу',
      ordersDetailsSelectedRate: 'Выбранный тариф',
      ordersDetailsSelectedRateCustomerAmount: 'Сумма для клиента',
      ordersDetailsSelectedRateCarrierAmount: 'Сумма перевозчика',
      ordersDetailsSelectedRateCarrierCurrency: 'Валюта',
      ordersDetailsSelectedRateDeliveryDays: 'Срок доставки, дн.',
      ordersDetailsSelectedRateNotes: 'Примечания',
      ordersDetailsRates: 'Тарифы',
      ordersDetailsParcels: 'Посылки',
      ordersDetailsPackerBoxes: 'Коробки',
      ordersDetailsPackerResponse: 'Ответ упаковщика',
      ordersDetailsShipments: 'Отправления',
      ordersDetailsNoShipments: 'Нет отправлений по этому заказу',
      ordersDetailsExternalOrderNumber: 'Внешний номер заказа',
      ordersDetailsCarrierOrderNumber: 'Номер заказа у перевозчика',
      ordersDetailsReference: 'Референс',
      ordersDetailsAmounts: 'Суммы',
      ordersDetailsLabelFields: 'Поля этикетки',
      ordersDetailsPlannedBoxes: 'Плановые коробки',
      ordersDetailsActualBoxes: 'Фактические коробки',
      ordersDetailsCalcId: 'ID',
      ordersDetailsCalcCreated: 'Создано',
      ordersDetailsCalcProvider: 'Провайдер',
      ordersDetailsCalcDeliveryType: 'Тип доставки',
      ordersDetailsCalcPickupPoint: 'Пункт выдачи',
      ordersDetailsCalcOrigin: 'Откуда',
      ordersDetailsCalcDestination: 'Куда',
      ordersDetailsCalcParcels: 'Коробки, ДxШxВ, кг',
      boxesEditorTitle: 'Редактор коробок',
      boxesEditorOpen: 'Редактировать коробки',
      boxesEditorSectionPlanned: 'ПЛАН',
      boxesEditorSectionActual: 'ФАКТ',
      boxesEditorAddBox: 'Добавить коробку',
      boxesEditorAddBoxTitle: 'Добавить коробку',
      boxesEditorAddBoxConfirm: 'Добавить',
      boxesEditorAddBoxFailed: 'Не удалось добавить коробку',
      boxesEditorRemoveBox: 'Удалить коробку',
      boxesEditorRemoveBoxFailed: 'Не удалось удалить коробку',
      boxesEditorAddBoxInvalid: 'Выбранная коробка недействительна',
      boxesEditorAddBoxWeightRequired: 'Укажите вес коробки',
      boxesEditorAddBoxWeightInvalid: 'Вес должен быть от 0,01 до 20,00 кг',
      boxesEditorAddBoxWeightHint: '0,01–20,00',
      boxesEditorActualLoadFailed: 'Не удалось загрузить фактические коробки',
      boxesEditorActualLocked: 'Фактические коробки нельзя изменить после создания отправления',
      boxesEditorNone: 'Нет плановых коробок',
      boxesEditorDimensions: 'Д×Ш×В, см',
      boxesEditorWeight: 'Вес, кг',
      boxesEditorVolume: 'Объём, см³',
      ordersDetailsShipmentId: 'ID',
      ordersDetailsShipmentStatus: 'Статус',
      ordersDetailsShipmentProvider: 'Провайдер',
      ordersDetailsShipmentTracking: 'Трек-номер',
      ordersDetailsShipmentServiceCode: 'Код услуги',
      ordersDetailsShipmentServiceType: 'Тип услуги',
      ordersDetailsShipmentPricingRule: 'Правило ценообразования',
      ordersDetailsShipmentCreated: 'Создано',
      ordersDetailsShipmentUpdated: 'Обновлено',
      ordersPayloadsListTitle: 'Отправления/черновики',
      ordersCreateShipment: 'Создать отправление',
      ordersCreateShipmentDraft: 'Создать черновик отправления',
      ordersCreateShipmentWarningTitle: 'Создать отправление из консоли?',
      ordersCreateShipmentWarningMessage:
        'Настоятельно не рекомендуется создавать отправление из консоли FiluetShip. Регистрация отправления — ответственность склада. Если вы понимаете риски и последствия, можете продолжить. В противном случае отмените действие.',
      ordersCreateShipmentWarningProceed: 'Всё равно продолжить',
      ordersCreateShipmentWarningAbort: 'Отмена',
      ordersCreateMissingCompany: 'Выберите активную компанию перед созданием отправления',
      ordersCreateShipmentModalTitle: 'Создать черновик отправления',
      ordersCreateData: 'Данные заказа',
      ordersCreateRewardPoints: 'Бонусные баллы',
      ordersCreateDeclaredValueTotal: 'Объявленная стоимость',
      ordersCreateRecipient: 'Получатель',
      ordersCreateRecipientName: 'Имя',
      ordersCreateRecipientPhone: 'Телефон',
      ordersCreateRecipientEmail: 'Email',
      ordersCreateItems: 'Позиции заказа',
      ordersCreateItemSku: 'SKU',
      ordersCreateItemSkuSelect: 'Выберите SKU',
      ordersCreateItemQuantity: 'Количество',
      ordersCreateItemAdd: 'Добавить',
      ordersCreateItemRemove: 'Удалить',
      ordersCreateRequiredFields: 'Номер заказа и клиент обязательны',
      ordersCreateRewardPointsInvalid: 'Бонусные баллы должны быть числом',
      ordersCreateDeclaredValueInvalid: 'Объявленная стоимость должна быть числом',
      ordersCreateRecipientNameRequired: 'Имя получателя обязательно',
      ordersCreateRecipientPhoneRequired: 'Телефон получателя обязателен',
      ordersCreateRecipientEmailRequired: 'Email получателя обязателен',
      ordersCreateRecipientEmailInvalid: 'Некорректный email',
      ordersCreateItemsRequired: 'Добавьте хотя бы одну позицию',
      ordersCreateItemSkuRequired: 'Выберите SKU из списка',
      ordersCreateItemQuantityInvalid: 'Количество должно быть положительным числом',
      ordersCreateFailed: 'Не удалось создать отправление',
      ordersDeleteConfirm: 'Удалить этот расчёт? Это действие нельзя отменить.',
      ordersDeleteFailed: 'Не удалось удалить расчёт',
      ordersDeleteConfirmed: 'Нельзя удалить расчёт, подтверждённый клиентом',
      ordersDeleteHasShipments: 'Нельзя удалить расчёт, для которого уже есть отправления',
      ordersDeleteWarningTitle: 'Удалить расчёт?',
      ordersDeleteWarningMessage:
        'Будут удалены calculation payload и связанный calculation. Это действие нельзя отменить.',
      ordersDeleteWarningProceed: 'Удалить',
      ordersDeleteWarningAbort: 'Отмена',
      Deleting: 'Удаление',
      ordersCreateWidgetTitle: 'Виджет доставки',
      ordersCreateWidgetMissingPayload: 'Отсутствует расчётная нагрузка',
      ordersCreateWidgetMissingApiKey: 'В настройках компании widgetConfig должен содержать apiKey',
      ordersCreateWidgetConfigMissing:
        'В настройках компании отсутствует widgetConfig. Добавьте его в settings.widgetConfig.',
      ordersCreateWidgetConfigLoadFailed: 'Не удалось загрузить настройки виджета компании',
      shipmentEditorRoutingOrigin: 'Маршрут: отправитель',
      shipmentEditorRoutingDestination: 'Маршрут: получатель',
      shipmentEditorRoutingReferences: 'Маршрут: референсы',
      shipmentEditorLabelImages: 'Изображения этикетки',
      shipmentEditorLabelImagesLoading: 'Загрузка изображений этикетки…',
      shipmentEditorLabelImagesNone: 'Изображения этикетки недоступны',
      shipmentEditorLabelImagesError: 'Не удалось загрузить изображения этикетки',
      shipmentEditorLabelPage: 'Страница этикетки {{n}}',
      shipmentEditorPrintLabel: 'Печать',
      shipmentEditorZoomIn: 'Увеличить',
      shipmentEditorZoomOut: 'Уменьшить',
      shipmentEditorBoxes: 'Коробки',
      shipmentEditorBoxesNone: 'Нет коробок',
      shipmentEditorBoxKind: 'Тип',
      shipmentEditorBoxPlanned: 'План',
      shipmentEditorBoxActual: 'Факт',
      shipmentEditorBoxCode: 'Код коробки',
      shipmentEditorBoxQty: 'Кол-во',
      shipmentEditorTitle: 'Редактор отправления — {{id}}',
      shipmentEditorOpen: 'Открыть редактор отправления',
      shipmentEditorEdit: 'Изменить',
      shipmentEditorEditTitle: 'Изменить отправление {{id}}',
      shipmentEditorEditDeliveryType: 'Тип доставки',
      shipmentEditorEditCourier: 'Курьер',
      shipmentEditorEditPickupPoint: 'Пункт выдачи',
      shipmentEditorEditComment: 'Комментарий',
      shipmentEditorEditReceiverName: 'Получатель',
      shipmentEditorEditReceiverMobile: 'Мобильный',
      shipmentEditorEditReceiverEmail: 'Email',
      shipmentEditorEditCity: 'Город',
      shipmentEditorEditStreet: 'Улица',
      shipmentEditorEditHouseNo: 'Дом',
      shipmentEditorEditApartmentNo: 'Квартира',
      shipmentEditorEditPostalCode: 'Индекс',
      shipmentEditorEditPickupPointId: 'Пункт выдачи',
      shipmentEditorEditPickupPointSelect: 'Выберите пункт выдачи',
      shipmentEditorEditPickupPointsLoading: 'Загрузка пунктов выдачи…',
      shipmentEditorEditPickupPointsError: 'Не удалось загрузить пункты выдачи',
      shipmentEditorEditCountryRequired: 'Для загрузки пунктов выдачи нужна страна назначения',
      shipmentEditorEditSave: 'Сохранить',
      shipmentEditorEditSaving: 'Сохранение…',
      shipmentEditorEditError: 'Не удалось изменить отправление',
      shipmentEditorEditPickupPointRequired: 'Для доставки в пункт выдачи нужно выбрать пункт',
      shipmentEditorDelete: 'Удалить',
      shipmentEditorDeleteError: 'Не удалось удалить отправление',
      copiedToClipboard: 'Скопировано в буфер обмена',
      scrollToTop: 'Наверх',
      mainDashboard: 'Главная панель',
      mainDashboardEyebrow: 'Операции / {{environment}}',
      mainDashboardSubtitle: 'Актуальная сводка по доставке. С возвращением, {{name}}.',
      mainDashboardShipmentRequests: 'Запросы на отправку',
      mainDashboardShipmentRequestsHint: 'Все запросы на расчёт',
      mainDashboardRegisteredShipments: 'Зарегистрированные отправления',
      mainDashboardRegisteredShipmentsHint: 'Созданы у перевозчиков',
      mainDashboardDelivered: 'Доставлено',
      mainDashboardFailureRate: 'Доля ошибок {{value}}',
      mainDashboardServiceHealth: 'Состояние сервисов',
      mainDashboardOperational: 'Работает',
      mainDashboardUnavailable: 'Недоступен',
      mainDashboardCheckingHealth: 'Проверяем состояние сервисов...',
      mainDashboardCarrierReadiness: 'Готовность перевозчиков',
      mainDashboardConnectedIntegrations: 'Подключённые интеграции с перевозчиками',
      mainDashboardPickupPointsSynced: 'Синхронизировано пунктов выдачи: {{count}}',
      mainDashboardManageIntegrations: 'Управлять интеграциями',
      mainDashboardOpenObservability: 'Открыть наблюдаемость',
      mainDashboardUpdatedAt: 'Обновлено в {{time}}',
      mainDashboardLoadingLiveData: 'Загрузка актуальных данных...',
      mainDashboardControlPlane: 'Центр управления FiluetShip',
      commandPaletteOpen: 'Открыть палитру команд (Ctrl+K)',
      commandPaletteTrigger: 'Поиск по навигации',
      commandPaletteLabel: 'Палитра команд',
      commandPalettePlaceholder: 'Поиск по консоли...',
      commandPaletteGoTo: 'Перейти',
      commandPaletteShipments: 'Отправления',
      commandPaletteNoMatches: 'Навигация и отправления не найдены',
      commandPaletteUnassigned: 'Не назначено',
      commandPaletteNoTracking: 'Трек-номера пока нет',
      commandPaletteDashboardHint: 'Обзор и состояние сервисов',
      commandPaletteShipmentsHint: 'Просмотр расчётов отправлений',
      commandPaletteIntegrationsHint: 'Управление интеграциями перевозчиков',
      commandPaletteObservabilityHint: 'События и активность системы',
      commandPalettePricingHint: 'Настройка цен и наценок',
      commandPaletteApiKeysHint: 'Управление доступом к API',
      commandPaletteClientsHint: 'Управление компаниями и пользователями',
      commandPalettePackagingHint: 'Управление вариантами упаковки',
      commandPaletteWebhooksHint: 'Просмотр доставок вебхуков',
      incidentsLabel: 'Операционные инциденты',
      incidentsControlPlane: 'Центр управления',
      incidentsTitle: 'Требуется внимание',
      incidentsClose: 'Закрыть инциденты',
      incidentsRequiringAttention: 'Требуют внимания',
      incidentsChecked: 'Проверено {{age}}',
      incidentsCheckingNow: 'Проверяем сейчас',
      incidentsServiceHealth: 'Состояние сервисов',
      incidentsServicesClear: 'Все отслеживаемые сервисы работают',
      incidentsShipmentExceptions: 'Исключения отправлений',
      incidentsNoExceptions: 'Нет исключений отправлений',
      incidentsUnknownOrder: 'Неизвестный заказ',
      incidentsNoTimestamp: 'Время не указано',
      providerDrawerLabel: 'Сведения о провайдере',
      providerDrawerTitle: 'Операции {{provider}}',
      providerDrawerClose: 'Закрыть сведения о провайдере',
      providerDrawerStatus: 'Статус подключения',
      providerDrawerPerformance: 'Показатели доставки',
      providerDrawerDelivered: 'Доставлено',
      providerDrawerFailure: 'Ошибки',
      providerDrawerAverageCost: 'Средняя стоимость',
      providerDrawerMappings: 'Сопоставления',
      providerDrawerPickupPoints: 'Пункты выдачи',
      providerDrawerLastSync: 'Последняя синхронизация',
      providerDrawerOpenIntegration: 'Открыть настройки интеграции',
      providerDrawerLatency: 'Средняя задержка', providerDrawerCredentials: 'Учётные данные', providerDrawerLastErrors: 'Последние ошибки', providerDrawerNoErrors: 'За период ошибок провайдера нет', providerDrawerProblemShipments: 'Проблемные отправления', providerDrawerNoProblems: 'Проблемных отправлений нет', providerDrawerLoadFailed: 'Не удалось загрузить сведения о провайдере',
      operationalMap: 'Операционная карта',
      operationalMapLabel: 'Карта сети доставки',
      operationalMapLoading: 'Загрузка сети доставки...',
      operationalMapEmpty: 'Нет операционных точек для отображения',
      operationalMapUnavailable: 'Операционная карта недоступна',
      operationalMapPickupPoints: 'Пункты выдачи',
      operationalMapShipments: 'Активные отправления',
      operationalMapProviders: 'Провайдеры',
      operationalMapZoomIn: 'Увеличить масштаб',
      operationalMapZoomOut: 'Уменьшить масштаб',
      operationalMapReset: 'Сбросить вид карты',
      operationalMapMissingKey: 'API-ключ Google Maps не настроен',
      operationalMapOpen: 'Открыть карту', operationalMapClose: 'Закрыть карту', operationalMapOnDemand: 'Загружайте точки выдачи только когда нужно проверить сеть доставки.',
      quickCreate: 'Быстрое создание',
      quickCreateOpen: 'Открыть быстрое создание',
      quickCreateClose: 'Закрыть быстрое создание',
      quickCreateShipment: 'Создать черновик отправления',
      quickCreateWebhook: 'Добавить вебхук',
      quickCreateIntegration: 'Добавить интеграцию',
      quickCreateApiKey: 'Создать API-ключ',
      quickCreatePricingRule: 'Создать правило ценообразования',
      quickCreateTitle: 'Что вы хотите создать?', quickCreateShipmentHint: 'Начать расчёт и выбрать доставку', quickCreateWebhookHint: 'Подключить внешний endpoint', quickCreateApiKeyHint: 'Выдать widget- или service-доступ', quickCreateIntegrationHint: 'Подключить аккаунт перевозчика', incidentsMarkRead: 'Прочитано', incidentsWebhooks: 'Вебхуки', incidentsNoWebhookFailures: 'Нет неуспешных доставок вебхуков', incidentsOpenFlower: 'Открыть монитор повторов', incidentsCredentials: 'Учётные данные', incidentsCheckCredentials: 'Проверить учётные данные интеграции', incidentsCredentialsClear: 'Все учётные данные провайдеров настроены',
      freshnessLive: 'Актуально',
      freshnessUpdatedMinutesAgo: 'Обновлено {{count}} мин назад',
      freshnessUpdatedHoursAgo: '{{count}} ч назад',
      freshnessUpdatedDaysAgo: '{{count}} дн. назад',
      freshnessStale: 'Устарело',
      freshnessUnknown: 'Актуальность неизвестна',
      freshnessLastUpdated: 'Последнее обновление: {{time}}',
      savedViews: 'Сохранённые представления',
      savedViewsSave: 'Сохранить текущее представление',
      savedViewsName: 'Название представления',
      savedViewsApply: 'Применить сохранённое представление',
      savedViewsDelete: 'Удалить сохранённое представление',
      savedViewsEmpty: 'Сохранённых представлений пока нет',
      savedViewsDefault: 'Представление по умолчанию',
      savedViewsSaveFailed: 'Не удалось сохранить представление',
      savedViewsDeleteFailed: 'Не удалось удалить представление',
      orderLifecycle: 'Жизненный цикл заказа',
      orderLifecycleCurrentStatus: 'Текущий статус: {{status}}',
      orderLifecycleCalculation: 'Рассчитан',
      orderLifecycleSelected: 'Тариф выбран',
      orderLifecycleRegistered: 'Зарегистрирован',
      orderLifecycleInTransit: 'В пути',
      orderLifecycleDelivered: 'Доставлен',
      orderLifecycleException: 'Исключение',
      orderLifecycleCancelled: 'Отменён',
      orderLifecyclePending: 'Ожидает',
      orderLifecycleUnknown: 'Статус неизвестен',
      asyncStateLoading: 'Загрузка...',
      asyncStateErrorTitle: 'Не удалось загрузить данные',
      asyncStateErrorDescription: 'При загрузке этого раздела произошла ошибка.',
      asyncStateEmptyTitle: 'Данных пока нет',
      asyncStateEmptyDescription: 'В этом разделе пока нечего отображать.',
      asyncStateRetry: 'Повторить',
      asyncStateDiagnostics: 'Открыть диагностику',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
